const authReducer = (
  state = {
    loading: false,
    data: {
      accessToken: null,
      uid: null,
      email: null,
      zones: null
    }
  },
  action
) => {
  switch (action.type) {
    case "SET_AUTH_LOADING":
      return { ...state, loading: action.payload.loading };

    case "SET_AUTH_INFO":
      return { ...state, data: action.payload };

    case "RESET":
      return {
        ...state,
        data: { accessToken: null, uid: null, email: null, zones: null }
      };

    default:
      return state;
  }
};

export default authReducer;
